import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
	selector: 'rbc-icon[circleColor]'
})
export class IconCircleColorDirective {
    constructor(private el: ElementRef, private renderer: Renderer2) {}
    _color: string = 'grey-light-tint-1';

    @Input() 
    set circleColor(color: string) {
       this._color = color ? color : this.circleColor;
       this.renderer.addClass(this.el.nativeElement, `b-${this._color}`);
    }
    get circleColor() {
        return this._color;
    }
}
